<template>
    <div class="d-flex flex-row justify-content-between"
         :class="{'shadow-sm': over}"
         style="margin-bottom: 3px;"
         v-on:mouseenter="over = true"
         v-on:mouseleave="over = false">
        <div v-if="show_sharing" style="width: 11%">
            <i class="fas fa-share-alt-square"></i>
        </div>

        <div v-if="show_count_of_joined" class="d-flex flex-row" style="width: 10%">
            <i class="fas fa-users" style="font-size: 1.4rem; margin-right: 4px;"></i>
            <span class="text-muted">
                {{count_of_joined}}
            </span>
        </div>

        <div v-if="show_percent_joined" style="width: 10%">
            %{{percent_joined}}
        </div>

        <div v-if="show_campaign" style="width: 10%">
            {{campaign}}
        </div>

        <div v-if="show_name" style="width: 10%">
            {{name}}
        </div>

        <div v-if="show_product_name" style="width: 10%">
            {{product_name}}
        </div>

        <div v-if="show_subtitle" style="width: 10%">
            {{subtitle}}
        </div>

        <div v-if="show_cost" style="width: 10%">
            ${{cost}}
        </div>

        <div v-if="show_end_date" style="width: 10%">
            {{format_date(end_date)}}
        </div>

        <div v-if="show_views" style="width: 10%">
            {{views}}
        </div>

        <div style="width: 10%">
            <ks-button v-if="button_action === 'add_to_cart'" :label="button_text" @onClick="onClick()"></ks-button>
            <router-link v-else-if="button_action === 'go_to_products_url'" class="nav-link" :to="{ path: product_url}">
                <ks-button :label="button_text"></ks-button>
            </router-link>
        </div>
    </div>
</template>

<script>
    import KsButton from "../button/index";
    import format_date from "../../mixins/formatDate";
    export default {
        /**
            tag
            name: ks-product-list
            description: product list
        **/
        name: "product_list",
        components: {KsButton},
        props: {
            /**
                attribute
                name: id 
                description: id
            **/
            id: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: height 
                description: height
            **/
            height: {
                type: String,
                default: "auto"
            },
            /**
                attribute
                name: count_of_joined 
                description: count_of_joined
            **/
            count_of_joined: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_count_of_joined 
                description: show_count_of_joined
            **/
            show_count_of_joined: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: image_source 
                description: image_source
            **/
            image_source: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_image 
                description: show_image
            **/
            show_image: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: button_text 
                description: button_text
            **/
            button_text: {
                type: String,
                default: "Add"
            },
            /**
                attribute
                name: percent_joined 
                description: percent_joined
            **/
            percent_joined: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_percent_joined 
                description: show_percent_joined
            **/
            show_percent_joined: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: cost 
                description: cost
            **/
            cost: {
                type: String,
                default: '0.00'
            },
            /**
                attribute
                name: show_cost 
                description: show_cost
            **/
            show_cost: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: name 
                description: name
            **/
            name: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_name 
                description: show_name
            **/
            show_name: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: campaign 
                description: campaign
            **/
            campaign: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_campaign 
                description: show_campaign
            **/
            show_campaign: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: end_date 
                description: end_date
            **/
            end_date: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_end_date 
                description: show_end_date
            **/
            show_end_date: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: views 
                description: views
            **/
            views: {
                type: Number,
                default: 0
            },
            /**
                attribute
                name: show_views 
                description: show_views
            **/
            show_views: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: show_sharing 
                description: show_sharing
            **/
            show_sharing: {
                type: Boolean,
                default: true
            },
            /**
                attribute
                name: subtitle 
                description: subtitle
            **/
            subtitle: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_subtitle 
                description: show_subtitle
            **/
            show_subtitle: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: product_name 
                description: product_name
            **/
            product_name: {
                type: String,
                default: ""
            },
            /**
                attribute
                name: show_product_name 
                description: show_product_name
            **/
            show_product_name: {
                type: Boolean,
                default: false
            },
            /**
                attribute
                name: button_action 
                description: button_action
            **/
            button_action: { type: String, default: "add_to_cart" }, // add_to_cart, go_to_products_url
            /**
                attribute
                name: product_url 
                description: product_url
            **/
            product_url: { type: String, default: null }

        },
        mixins: [format_date],
        methods: {
            onClick() {
                this.$emit('onClick', this.id);
            }
        },
        data: function () {
            return {
                over: false

            }
        },
        computed: {}
    }
</script>
<style>

</style>
